import { Text } from "@/elements"
import { TextLink } from "@/elements/TextLink"
import { ProLockIcon } from "@/icons/outline"
import clsx from "clsx"
import { Tooltip } from "../Tooltip"

interface Props {
  title: string
  children: React.ReactNode
  isEditing?: boolean
  onEditClick?: () => void
  upsellSubscription?: boolean
  openProModal?: () => void
  creativeName?: string
}

export const MetadataSectionContainer: React.FC<Props> = ({
  title,
  children,
  isEditing,
  onEditClick,
  upsellSubscription,
  openProModal,
  creativeName,
}) => {
  return (
    <div>
      <div className={clsx("flex flex-row items-center gap-x-1", isEditing && "justify-between")}>
        <Text className="text-fg-2" variant="label">
          {title}
        </Text>
        {upsellSubscription && (
          <Tooltip
            trigger={<ProLockIcon className="size-5" />}
            text={`Join NOVA Pro to access ${creativeName}’s contact information`}
            button={{
              onClick: openProModal,
              children: (
                <Text variant="CTASmall">
                  Sign up for{" "}
                  <Text variant="CTASmall" element="span" className="text-pro-gradient">
                    NOVA Pro
                  </Text>
                </Text>
              ),
            }}
            width={269}
          />
        )}

        {isEditing && <TextLink text="Edit" underline onClick={onEditClick} />}
      </div>
      <div className="mt-4">{children}</div>
    </div>
  )
}
